'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactIconBase = require('react-icon-base');

var _reactIconBase2 = _interopRequireDefault(_reactIconBase);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var IoIosBookmarksOutline = function IoIosBookmarksOutline(props) {
    return _react2.default.createElement(
        _reactIconBase2.default,
        _extends({ viewBox: '0 0 40 40' }, props),
        _react2.default.createElement(
            'g',
            null,
            _react2.default.createElement('path', { d: 'm33.6 5c1.5 0 2.6 1 2.6 2.5v22.3c0 1.5-1.1 2.7-2.6 2.7h-11.2s-1.9 0.3-1.9 1.5v1h-1.3v-1c0-1.2-0.9-1.5-1.9-1.5h-11.2c-1.5 0-2.6-1.2-2.6-2.7v-22.3c0-1.5 1.1-2.5 2.6-2.5h11.7c0.8 0 1.6 0.4 2 0.9 0.5-0.5 1.3-0.9 2.1-0.9h11.7z m-14.4 27.1v-24.1c0-0.7-0.9-1.8-1.9-1.8h-11.2c-0.7 0-1.3 0.6-1.3 1.3v22.3c0 0.7 0.6 1.4 1.3 1.4h11.2c0.8 0 1.5 0.3 1.9 0.9z m5.6-25.8v7.8l1.8-1.1 0.7-0.5 0.7 0.5 1.8 1.1v-7.8h-5z m10 23.5v-22.3c0-0.7-0.5-1.2-1.2-1.2h-2.5v10.2l-3.8-2.5-3.7 2.5v-10.2h-1.2c-1 0-1.9 1-1.9 1.7v24.1c0.3-0.7 1-0.8 1.8-0.8h11.3c0.7 0 1.2-0.8 1.2-1.5z' })
        )
    );
};

exports.default = IoIosBookmarksOutline;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./~/react-icons/lib/io/ios-bookmarks-outline.js
// module id = 2324
// module chunks = 0